import React from 'react';
import { Svg, ISvg } from '../Svg';

export const Features: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M18.75 27.084C17.375 27.7715 16.2292 28.7923 15.375 30.0632C14.8958 30.7923 14.8958 31.709 15.375 32.4381C16.2292 33.709 17.375 34.7298 18.75 35.4173"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6875 27.084C33.0625 27.7715 34.2083 28.7923 35.0625 30.0632C35.5417 30.7923 35.5417 31.709 35.0625 32.4381C34.2083 33.709 33.0625 34.7298 31.6875 35.4173"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 45.8327H31.25C41.6667 45.8327 45.8333 41.666 45.8333 31.2493V18.7493C45.8333 8.33268 41.6667 4.16602 31.25 4.16602H18.75C8.33332 4.16602 4.16666 8.33268 4.16666 18.7493V31.2493C4.16666 41.666 8.33332 45.8327 18.75 45.8327Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.64584 16.6868L44.6875 16.666"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
